<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      v-if="!$_.isNil(matchShowingBadgesField)"
      :field="`conditionsRequirements.${matchShowingBadgesField}`"
      value-type="String"
      class="col-12"
      :label="`Matching ${$_.startCase(conditional.conditionsRequirements[matchShowingBadgesField])} Showing Badges`"
      :options="$mh.asOptions(MATCH_SHOWING_BADGES_BY.ALL)"
      map-options
      emit-value
      :rules="[val => !!val || 'Field is required']"
    />
    <model-form-select
      :field="showingBadgesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeShowingBadgesField] ? 'Exclude' : 'Include')} Showing Badges`"
      :options="showingBadges.data"
      option-label="displayName"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one showing badge'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeShowingBadgesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS, MATCH_SHOWING_BADGES_BY } from 'src/models/item/Category'

export default {
  name: 'ShowingBadgesConditionForm',
  configuration: ['showingBadges'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    showingBadgesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.SHOWING_BADGES
    },
    excludeShowingBadgesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_SHOWING_BADGES
    },
    matchShowingBadgesField: {
      type: String,
      default: null
    }
  },
  created () {
    _.extend(this, { MATCH_SHOWING_BADGES_BY })
  }
}

</script>
